export const setProducts = (products = {}) => ({
  type: 'SET_PRODUCTS',
  products
})

export const setBrands = (brands = {}) => ({
  type: 'SET_BRANDS',
  brands
})